import React from "react";
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import PayPalIcon from '../../../assets/svg/paypal.svg';

const PayPalResult = ({ link }) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div className={classes.paymentModalInner}>
            <div>
                <img src={PayPalIcon} alt="paypal-logo" className={classes.paymentModalBrandImg} />
            </div>
            <div className="payment-modal-info">
                <label>{t("PayPal_complete_label")}</label>
            </div>
        </div>
    )
}

export default PayPalResult;